import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {Helmet} from "react-helmet";
import {metaDescriptions, metaTitles, title} from "../website-utils/meta";
import ScrollToTopOnMount from "../website-utils/ScrollToTopOnMount";
import {Link} from "react-router-dom";
import config from "../config";
import logoBlack from '../assets/images/logo-black.png';
import Typography from '@material-ui/core/Typography';


class NotFoundPage extends Component  {
  componentDidMount() {
    window.analytics.page("Not Found");
  }

  render() {
    const {classes} = this.props;

    return (
      <div className={classes.content}>
        <Helmet>
          {title('SingleShift - Page Not Found')}
          {metaTitles('SingleShift - Page Not Found')}
          {metaDescriptions("We couldn't find this page. Try checking if the URL is correct.")}
        </Helmet>
        <ScrollToTopOnMount/>
        <div className={classes.container}>
          <Link to={config.routes.home}>
            <img className={classes.logo} src={logoBlack}/>
          </Link>
          <Typography variant='display2' className={classes.message}>
            Oops. 
          </Typography>
          <Typography variant='body2' className={classes.brief}>
            Sorry, we can't find the page you're looking for.
          </Typography>
          <Link to={config.routes.home}>
            Go to SingleShift
          </Link>
        </div>
      </div>
    );
  }
}

const styles = (theme) => ({
  content: {
    minHeight: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    // backgroundImage: `url(${notFoundImage})`,
    backgroundPosition: 'center',
    padding: theme.spacing.unit * 2,
  },
  container: {
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      position: 'relative',
      top: '-10vh',
    }
  },
  logo: {
    width: 200,
    marginBottom: theme.spacing.unit * 4,
  },
  message: {
    fontWeight: 'bold',
    marginBottom: theme.spacing.unit * 2,
  },
  brief: {
    marginBottom: theme.spacing.unit * 6,
    '& p': {
    },
  },
  callToActions: {
    maxWidth: '600px',
    margin: '0 auto',
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      justifyContent: 'center',
    }
  },
  button: {
    margin: `${theme.spacing.unit * 2}px 0`,
    [theme.breakpoints.up('md')]: {
      flexBasis: '50%',
      margin: '0 16px',
    },
  },
});


export default withStyles(styles)(NotFoundPage);


// WEBPACK FOOTER //
// ./src/pages/NotFoundPage.js